import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ViewwarningComponent } from '../viewwarning/viewwarning.component';

@Component({
  selector: 'app-checkwarning',
  templateUrl: './checkwarning.component.html',
  styleUrls: ['./checkwarning.component.scss']
})
export class CheckwarningComponent implements OnInit {

  ignore = false
  constructor(
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<CheckwarningComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  closeModal() {
    this.dialogRef.close();
  }

  viewWarning() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.height = "70vh";
    dialogConfig.width = "80vw";
    dialogConfig.id = "viewwarning-component";
    dialogConfig.data = this.modalData;
    const modalDialog = this.matDialog.open(ViewwarningComponent, dialogConfig);
    modalDialog.afterClosed().subscribe((result) => {
      this.dialogRef.close();
    });
  }
  next() {
    this.dialogRef.close(true);
  }

  ngOnInit(): void {

  }

}
